import { IndexableType } from 'dexie'
import { GlobalIndexDbService, IGlobalDataDoc } from './globalIndexDb.service'

export type globalData = Array<IGlobalDataDoc>

export class GlobalDataService {
  private db: GlobalIndexDbService
  private tableName: string

  constructor() {
    this.db = new GlobalIndexDbService()
    this.tableName = this.db.globalData.name
  }

  async getAllDoc(): Promise<globalData> {
    return await this.db.getAll(this.tableName)
  }

  async removeDoc(id: string): Promise<void> {
    return await this.db.remove(id, this.tableName)
  }

  async getDocument(id: string): Promise<IGlobalDataDoc | undefined | null> {
    return await this.db.get(id, this.tableName)
  }

  async createDocument(document: IGlobalDataDoc): Promise<IndexableType> {
    return this.db.addWithKey(document, this.tableName, document.id)
  }

  async updateDocument(document: IGlobalDataDoc): Promise<IndexableType> {
    return this.db.update(document.id, document, this.tableName)
  }

  async createOrUpdateDocument(document: IGlobalDataDoc) {
    return this.db.createOrUpdate(document.id, document, this.tableName)
  }

  async isEmpty() {
    return this.db.isEmpty(this.tableName)
  }
}
